import { useState, useEffect, useCallback } from 'react';
import { tokenUtils } from '../../../utils/tokenUtils';
import { toast } from 'react-toastify';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(tokenUtils.hasToken());
  const [user, setUser] = useState(null);

  // Logout function
  const logout = useCallback(() => {
    tokenUtils.removeToken();
    setIsAuthenticated(false);
    setUser(null);
    toast.info('You have been logged out');
    window.location.href = '/login';
  }, []);

  // Only check token validity on mount - no intervals
  useEffect(() => {
    if (isAuthenticated && tokenUtils.isTokenExpired()) {
      logout();
    }
  }, [isAuthenticated, logout]);

  // Load user data if authenticated
  useEffect(() => {
    if (isAuthenticated) {
      const userData = localStorage.getItem('user');
      if (userData) {
        try {
          setUser(JSON.parse(userData));
        } catch (error) {
        }
      }
    }
  }, [isAuthenticated]);

  return {
    isAuthenticated,
    user,
    logout
  };
};